module.exports = __webpack_public_path__ + "static/media/Bureau_38.63952a38.jpg";